const validateHooyuUrl = (url: string) =>
  url?.startsWith('https://www.hooyu.com/') ||
  url?.startsWith('https://hooyu.com/') ||
  url?.startsWith('https://eu.id.miteksystems.com/');

export default validateHooyuUrl;
